import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import { partnerOidcSettings } from '../../config/oidc';

export default vuexOidcCreateStoreModule(
    partnerOidcSettings,
    {
        namespaced: true,
        dispatchEventsOnWindow: true,
        automaticSilentRenew: false,
        automaticSilentSignin: false,
    },
    // Optional OIDC event listeners
    {
        // userLoaded: user => console.log(user),
        // userUnloaded: () => console.log('OIDC user is unloaded'),
        // accessTokenExpiring: () => console.log('Access token will expire'),
        // accessTokenExpired: () => console.log('Access token did expire'),
        // silentRenewError: () => console.log('OIDC user is unloaded'),
        // userSignedOut: () => console.log('OIDC user is signed out'),
        oidcError: payload => handleError(payload),
        // automaticSilentRenewError: payload => console.log('OIDC automaticSilentRenewError', payload),
    },
);

// eslint-disable-next-line no-unused-vars
function handleError(payload) {
    // console.log('OIDC error', payload);
}
